// App.js

import "./App.css";

import {
  BrowserRouter,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";

import Home from "./Components/Layout";

import LoginScreen from "../src/LoginScreen";

import Dashboard from "./Pages/Dashboard";
import Products from "./Pages/Products";
import AddProduct from "./Pages/AddProduct";
import EditProduct from "./Pages/EditProduct";
import ProductDetails from "./Pages/ProductDetails";
import DeletePopup from "./Pages/DeletePopup";

import Orders from "./Pages/Orders";
import OrderDetails from "./Pages/OrderDetails";

import Payments from "./Pages/Payments";
import PaymentDetails from "./Pages/PaymentDetails";

import Customers from "./Pages/Customers";
import CustomerDetails from "./Pages/CustomerDetails";

import AdminProfile from "./Pages/AdminProfile";
import EditProfilePopup from "./Pages/EditProfilePopup";
import ChangePasswordModal from "./Pages/ChangePasswordModal";
import LogoutPopup from "./Pages/LogoutPopup";
import Notifications from "./Pages/Notifications";
import ContentSettings from "./Pages/ContentSettings";

function AppRoutes() {
  const location = useLocation();

  const state = location.state;
  const background = state?.background;

  return (
    <>
      <Routes location={background || location}>
        {/* Login Route */}
        <Route path="/" element={<LoginScreen />} />

        {/* Dashboard Layout Routes */}
        <Route path="/" element={<Home />}>
          <Route path="dashboard" element={<Dashboard />} />

          {/* Products */}
          <Route path="products" element={<Products />} />
          <Route path="add-product" element={<AddProduct />} />
          <Route path="edit-product/:id" element={<EditProduct />} />
          <Route path="product-details/:id" element={<ProductDetails />} />

          {/* Orders */}
          <Route path="orders" element={<Orders />} />
          <Route path="order-details/:id" element={<OrderDetails />} />

          {/* Payments */}
          <Route path="payments" element={<Payments />} />
          <Route path="payment-details/:id" element={<PaymentDetails />} />

          {/* Customers */}
          <Route path="customers" element={<Customers />} />
          <Route path="customer-details/:id" element={<CustomerDetails />} />

          {/* Content & Settings */}
          <Route path="content-settings" element={<ContentSettings />} />

          {/* Profile */}
          <Route path="admin-profile" element={<AdminProfile />} />
          <Route path="notifications" element={<Notifications />} />

          {/* Popup Routes */}
          <Route path="editprofilepopup" element={<EditProfilePopup />} />

          <Route
            path="changepasswordpopup"
            element={
              <ChangePasswordModal onClose={() => window.history.back()} />
            }
          />

          <Route path="logoutpopup" element={<LogoutPopup />} />
        </Route>
      </Routes>

      {/* Modal Routes */}
      {background && (
        <Routes>
          <Route path="/delete-popup" element={<DeletePopup />} />

          <Route path="/editprofilepopup" element={<EditProfilePopup />} />

          <Route
            path="/changepasswordmodal"
            element={
              <ChangePasswordModal onClose={() => window.history.back()} />
            }
          />

          <Route path="/logoutpopup" element={<LogoutPopup />} />
        </Routes>
      )}
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppRoutes />
    </BrowserRouter>
  );
}

export default App;